export const COMMON_DATE = "MMM Do 'YY";
export const SHORT_DATE = "MMM-D-'YY";

// Explanation
export const clueExplanationCode1 = "A clue can have text, an image, and, finally, an answer code to release the next clue. "
   + "The text and image should lead to the code so the user can solve it. ";

export const clueExplanationCode2 = "A clue also has a specific location and photo for its answer (not revealed) and a map \"search bounds\", shown"
   + " to the user as an area in which the answer will be found."
   // + " or on a piece of tape, or if it's a thing found at the location.  Use the map to specify the exact location of the "
   // + " answer.  This will be shown to the user only after they solve the clue or give up), or potentially as a hint to the user. "
   // + "Not required, but strongly encouraged";

export const clueMapDirection = "\n\n";

export const clueExplanationTime = "A clue needs text and a time to release the next clue. "
   + "That time needs to be a duration in minutes after this clue is released.  If this hunt is an event hunt, "
   + "i.e. with a specific start time, the first clue is released at that time and subsequent clues are released "
   + "at the interval given by this clue duration.  In any case, the clue should serve as a hint to the final treasure. ";
export const clueExplanationTime2 = "Clues in a clue-countdown hunt do not have map bounds.";

export const clueExplanationMixed = "A clue needs text and a way to release the next clue -- either "
   + "a time duration or an answer code, or both. ";
export const clueExplanationMixed2 = "Mixed hunt clues can have clue bounds.  It may or may not make sense for a particular clue, it is up "
   + "to the author.";

export const annotationExplanation = "You can optionally enter a private title (i.e. annotation) "
   + "by which to identify this clue -- it is never displayed to the user.";

export const clueEndingParagraphMixed = "Unless this is the very last clue, there needs to be a way to release the next clue.  "
   + "For mixed hunts, this can be either after some amount of time passes, or when the user enters an answer code,  "
   + "or both.  The duration specifies the elapsed time, in minutes, until the next clue is released. "
   + "The answer code is the code the user enters to solve the current clue.  You can, if you choose, use both "
   + "duration and code release.  I.e have the next clue released when the answer code is given or, if that doesn't "
   + "happen, when the time elapses.";

export const clueFurtherExplanation = "Further explanation: The main part of the clue is the text and/or picture.  These typically " +
   " provide the key to the riddle of the clue, i.e. the way to finding and solving the answer code.  To the user, a clue also has an " +
   " icon which appears alongside the text, a search bounds on the map, and, potentially, an exact map location which they might " +
   " choose to view as a hint. ";
// The text can also serve other purposes, of course, such "
// + "as a hint to the final treasure or future clues. ";
// can typically be found at a specific place -- whether it be hidden in a vial

// + " or on a piece of tape, or if it's a thing found at the location.  Use the map to specify the exact location of the "
// + " answer.  This will be shown to the user only after they solve the clue or give up), or potentially as a hint to the user. "
// + "Not required, but strongly encouraged";

// export const clueExplanationCode3 = "Along with a lat-lon location, clues should also have bounds, within which the clue answer can be found.  Not technically "
//    + "required, it can be helpful and fun for the player to narrow down where the clue might be based on the bounds.  "
//    + "Once you place the clue answer in its exact location, drag and resize the bounds that appears around it to the area you want the user "
//    + "to search within.";



export const clueFurtherExplanationParagraph2 = "There is no limit to the length or content of the text, but you" +
   " should use discretion as the user will have to read all of your text on their mobile device.  Between them, the" +
   " text and picture should aid in the hunt -- giving information about how to get to the next clue and possibly, how to find the final treasure." +
   " If your clue is" +
   " composed of verse, such as with rhymes, note that line length on a mobile device can be short." +
   " Keep it under about 42 characters to be safe on most devices as longer lines will wrap.";

export const clueEndingParagraphCode = "The answer code is the text the user enters to solve the current clue and move on."
   + " If this is the last clue, entering this code shows the user won the hunt!"
   + " The code must be alphanumeric (letters, numbers, spaces, dashes, underscore, apostrophe only) and"
   + " the user will have to enter it on their mobile device.  To help the user, upper and lower case are ignored in the answer, as are spaces.";


export const clueFurtherExplanationParagraph3 = "The clue search bounds are a fun way to" +
   " direct the user toward your clue's location.  The user heads to that area as shown on the map, and solves the clue." +
   " Search bounds are recommended though not strictly required.";

export const clueFurtherExplanationParagraph4 =
   "You are also asked to enter the exact location of the clue answer.  Answers will typically be a word written and" +
   " hidden at a specific location, or an object at a location.  Pinpoint that location on the map." +
   " This will be shown to the user when they get or take the `Reveal location` hint, or after they solve the clue";

export const clueFurtherExplanationParagraph5 =
   "Adding a photo of the answer is recommended, though not required.  " +
   " This should be a picture you take of the thing users are supposed to find.  The picture should help them easily" +
   " locate the answer.  It is only shown to the the user after the clue.  Seeing where the answer was can be reassuring if" +
   " the person was frustrated, and might also allow the user to repair a broken clue or notify you if the answer is missing."




// WEBPACK FOOTER //
// ./src/constants/Strings.js